module.exports = __webpack_public_path__ + "static/media/TommyHoodNormal.8287a4a8.jpg";